import React, { useState, useContext, useEffect } from 'react';
import PageContext from '../../contexts/pageContext';
import useAboutInstituteStyles from './styles';
import NextImageRenderer from '../../components/nextImageRenderer';
import Icon from '../../icon';
import { useTheme } from '../../theme/theming';

export default function ABOUT_INSTITUTE({ sectionData, sectionIndex }) {
  const {
    layout: { containerWidth },
    isMobile
  } = useContext(PageContext);

  const classes = useAboutInstituteStyles({ containerWidth, isMobile });
  const [nodeData] = sectionData?.components;
  const [highlightNodeData] = nodeData?.highlight?.components;

  const theme = useTheme();

  const ImageJSX = () => {
    if (!nodeData?.image?.metadata?.value) {
      return null;
    }
    return (
      <div className={classes.imageContainer}>
        <NextImageRenderer
          className={classes.image}
          alt="logo"
          src={nodeData?.image?.metadata?.value}
        />
      </div>
    );
  };

  const ContentJSX = () => (
    <div className={classes.infoContainer}>
      <div className={classes.infoDetails}>
        {nodeData?.instName?.metadata?.value ? (
          <div
            className={classes.instHeading}
            ref={nodeData?.instName?.refSetter}
            dangerouslySetInnerHTML={{
              __html: nodeData?.instName?.metadata?.value
            }}
          />
        ) : null}
        <div className={classes.metaInfo}>
          {nodeData?.spec?.metadata?.value ? (
            <div className={classes.metaInfoChild}>
              <Icon
                name={'BookSaved'}
                color={theme.palette.font.primary}
                width={'20px'}
                height={'20px'}
              />
              <div
                className={classes.metaChild}
                ref={nodeData?.spec?.refSetter}
                dangerouslySetInnerHTML={{
                  __html: nodeData?.spec?.metadata?.value
                }}
              />
            </div>
          ) : null}
          {nodeData?.qual?.metadata?.value ? (
            <div className={classes.metaInfoChild}>
              <Icon
                name={'Teacher'}
                color={theme.palette.font.primary}
                width={'20px'}
                height={'20px'}
              />
              <div
                className={classes.metaChild}
                ref={nodeData?.qual?.refSetter}
                dangerouslySetInnerHTML={{
                  __html: nodeData?.qual?.metadata?.value
                }}
              />
            </div>
          ) : null}
          {nodeData?.exp?.metadata?.value ? (
            <div className={classes.metaInfoChild}>
              <Icon
                name={'Medal'}
                color={theme.palette.font.primary}
                width={'20px'}
                height={'20px'}
              />
              <div
                className={classes.metaChild}
                ref={nodeData?.exp?.refSetter}
                dangerouslySetInnerHTML={{
                  __html: nodeData?.exp?.metadata?.value
                }}
              />
            </div>
          ) : null}
        </div>
      </div>
      {nodeData?.content?.metadata?.value ? (
        <div className={classes.infoContent}>
          <div className={classes.aboutText}>About</div>
          <div
            className={classes.instAbout}
            ref={nodeData?.content?.refSetter}
            dangerouslySetInnerHTML={{
              __html: nodeData?.content?.metadata?.value
            }}
          />
        </div>
      ) : null}
    </div>
  );

  const HighlightJSX = () => {
    if (!nodeData?.highlight?.metadata?.value) {
      return null;
    }
    return (
      <div className={classes.cardWrapper}>
        <div className={classes.card}>
          <div className={classes.cardDesc}>
            <span
              className={classes.highlightText}
              ref={highlightNodeData?.courses?.refSetter}
              dangerouslySetInnerHTML={{
                __html: highlightNodeData?.courses?.metadata?.value
              }}
            ></span>
            <span className={classes.highlightHeading}>Courses</span>
          </div>
          <Icon
            name={'BookSaved'}
            color={theme.palette.font.primary}
            width={'32px'}
            height={'32px'}
          />
        </div>
        <div className={classes.card}>
          <div className={classes.cardDesc}>
            <span
              className={classes.highlightText}
              ref={highlightNodeData?.students?.refSetter}
              dangerouslySetInnerHTML={{
                __html: highlightNodeData?.students?.metadata?.value
              }}
            ></span>
            <span className={classes.highlightHeading}>Active Students</span>
          </div>
          <Icon
            name={'GroupProfile'}
            color={theme.palette.font.primary}
            width={'32px'}
            height={'32px'}
          />
        </div>
      </div>
    );
  };

  return (
    <div className={classes.aboutInstWrapper}>
      {nodeData?.heading?.metadata?.value ? (
        <div className={classes.aboutInstText}>
          <span
            ref={nodeData?.heading?.refSetter}
            dangerouslySetInnerHTML={{
              __html: nodeData?.heading?.metadata?.value
            }}
          />
        </div>
      ) : null}

      {nodeData?.title?.metadata?.value ? (
        <h2 className={classes.aboutInstHeader}>
          <span
            ref={nodeData?.title?.refSetter}
            dangerouslySetInnerHTML={{
              __html: nodeData?.title?.metadata?.value
            }}
          />
        </h2>
      ) : null}

      {isMobile ? (
        <>
          <div className={classes.contentWrapper}>
            <ImageJSX />
            <HighlightJSX />
          </div>
          <ContentJSX />
        </>
      ) : (
        <>
          <div className={classes.contentWrapper}>
            <ImageJSX />
            <ContentJSX />
          </div>
          <HighlightJSX />
        </>
      )}
    </div>
  );
}
